import { IIndexable } from './IIndexable';

export class Phone {
  prefix: string | undefined;
  telephone: string | undefined;
  typeTelephone?: string;

  constructor(prefix: string | undefined, telephone: string | undefined, typeTelephone?: string) {
    this.prefix = prefix;
    this.telephone = telephone;
    this.typeTelephone = typeTelephone;
  }

  toString(): string {
    if (this.prefix) return `${this.prefix}-${this.telephone}`;
    return this.telephone ?? '';
  }

  static parse(obj: IIndexable): Phone {
    return new Phone(obj.prefix, obj.telephone, obj.typeTelephone);
  }
}
